<template>
  <v-dialog v-model="shouldAcceptTerms" scrollable persistent xs4 max-width="500">
    <v-card>
      <v-card-title>
        <h2>Godkjenning av avtalevilkår</h2>
      </v-card-title>

      <v-card-text>
        <notifications group="accept-terms" key="accept-terms" />

        <v-progress-linear v-if="isSubmitting" :indeterminate="true"></v-progress-linear>

        <p>
          Ved å gå inn på {{ config.MINSIDE_DOMAIN }} godtar jeg
          <a href="https://www.mekke.no/vilkar-23418s.html" target="_blank">Avtalevilkår for bruk av tjenester hos Mekke Media</a>
          med tilhørende personvernerklæring og databehandleravtale.
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          :disabled="isSubmitting"
          @click="submit"
          dark
        >Jeg godkjenner</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AuthenticationService from '@/services/AuthenticationService'

export default {
  props: ['dialogState'],
  data () {
    return {
      isSubmitting: false
    }
  },
  methods: {
    async submit () {
      const response = await this.runService(this, 'accept-terms', AuthenticationService.acceptTerms)
      if (response) {
        this.$store.dispatch('setAcceptedTerms', true)
      }
    }
  },
  computed: {
    shouldAcceptTerms () {
      return this.$store.state.token && !this.$store.state.acceptedTerms
    }
  }
}
</script>

<style scoped>
</style>
